var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { QueryObserver, MutationObserver } from '@tanstack/react-query';
/**
 * This service provides adapters for interacting with the QueryClient instance from Ember code.
 */
let EmberQuery = (_class = class EmberQuery extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "queryClient", _descriptor, this);
  }
  get queryClientInstance() {
    return this.queryClient.instanceV5;
  }

  // Returns a Promise that resolves with the query data or error. Does NOT create an observer.
  // Equivalent to https://tanstack.com/query/v4/docs/reference/QueryClient/#queryclientensurequerydata
  readQuery(queryDef) {
    return this.queryClientInstance.ensureQueryData(queryDef);
  }

  // Synchronously returns the query data for the given query key.
  // If the data is not present, returns undefined
  // Equivalent to https://tanstack.com/query/v4/docs/reference/QueryClient#queryclientgetquerydata
  getQueryData(queryDef) {
    return this.queryClientInstance.getQueryData(queryDef.queryKey);
  }

  // Invalidate all queries with the given query key
  // Equivalent to https://tanstack.com/query/v4/docs/reference/QueryClient#queryclientinvalidatequeries
  invalidateQueries(queryDef) {
    return this.queryClientInstance.invalidateQueries(queryDef);
  }

  // Creates an observer for the given query definition. Invokes callback when query status changes
  // Callback receives same data returned by useQuery hook (https://tanstack.com/query/v4/docs/framework/react/reference/useQuery)
  observeQuery(queryDef, callback) {
    const observer = new QueryObserver(this.queryClientInstance, queryDef);
    const unsubscribe = observer.subscribe(callback);
    const queryOpts = this.queryClientInstance.defaultQueryOptions(queryDef);
    callback(observer.getOptimisticResult({
      ...queryOpts,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      throwOnError: false
    }));
    return unsubscribe;
  }

  // Combines readQuery & observeQuery - returns a Promise with query data while also creating an observer
  async readAndObserveQuery(queryDef, callback, hasObserver) {
    const data = await this.readQuery(queryDef);
    let unsubscribe;
    if (!hasObserver) {
      // Subscribe to changes if we haven't already
      unsubscribe = this.observeQuery({
        ...queryDef,
        refetchOnMount: false
      }, callback);
    }
    return {
      data,
      unsubscribe
    };
  }

  // Creates a Mutation observer, invokes callback when the status changes.
  // Returns a mutate function that should be called in Ember with the mutation variables
  // Callback receives same data returned by useMutation hook (https://tanstack.com/query/v4/docs/framework/react/reference/useMutation)
  mutateQuery(queryDef, callback) {
    const observer = new MutationObserver(this.queryClientInstance, queryDef);
    if (callback) {
      observer.subscribe(callback);
    }
    return {
      mutate: observer.mutate
    };
  }

  // Performs mutateQuery and immediately invokes the mutate function with passed in variables.
  // Returns a promise with the result of the mutation.
  // Similar to the mutateAsync fn returned by useMutation hook (https://tanstack.com/query/v4/docs/framework/react/reference/useMutation)
  mutateQueryAsync(queryDef, variables, callback) {
    const {
      mutate
    } = this.mutateQuery(queryDef, callback);
    return mutate(variables);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "observeQuery", [action], Object.getOwnPropertyDescriptor(_class.prototype, "observeQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mutateQuery", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mutateQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mutateQueryAsync", [action], Object.getOwnPropertyDescriptor(_class.prototype, "mutateQueryAsync"), _class.prototype), _class);
export { EmberQuery as default };